import moment from '../../../moment'

const initialState = {
    filters: {
        endDate: moment().format('YYYY-MM-DD'),
        startDate: moment().subtract(30, 'days').format('YYYY-MM-DD')
    }
};

export default function orders(state = initialState, action = {}) {
    switch (action.type) {
        case 'UPDATE_ORDERS_FILTERS_FORM':
            return {
                ...state,
                filters: action.payload
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Orders/reducer.js